import { Routes } from '@angular/router';
import { authGuard } from './guard/auth.guard';

export const routes: Routes = [
    {
        path: 'auth/email',
        loadComponent: () => import('../app/modules/email-mfa/email-mfa.component').then(m => m.EmailMfaComponent)
    },
    {
        path: 'platform/auth/email',
        redirectTo: 'auth/email',
        pathMatch: 'full'
    },
    {
        path: 'layout',
        canActivate: [authGuard],
        loadChildren: () => import('../app/layout/layout.module').then(m => m.LayoutModule)
    },
    {
        path: 'resource-not-found',
        loadComponent: () => import('../app/shared/resource-not-found/resource-not-found.component').then(m => m.ResourceNotFoundComponent)
    },
    {
        path: '',
        loadChildren: () => import('../app/auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: '**',
        redirectTo: 'resource-not-found'
    }
];
